import DownloadApp from "./steps/DowloadApp";
import ScanQRCode from "./steps/ScanQRCode";
import BackupKey from "./steps/BackupKey";
import Enable2FA from "./steps/Enable2FA";
import Disable2FA from "./steps/Disable2FA";

export const ENABLED_STEPS = ["Download App", "Scan QR Code", "Backup Key", "Activated Google authenticator"];
export const ENABLED_STEPS_COMPONENTS = [DownloadApp, ScanQRCode, BackupKey, Enable2FA];
export const ENABLED_STEP_DESCRIPTIONS = [
  "Download and install the Google Authenticator app on your phone",
  "Scan the QR code in the Google Authenticator app",
  "Please save this key on paper. This Key will allow you to recover your Google Authenticator app in case of phone loss or theft",
  "Google Authenticator Code",
];

export const DISABLED_STEPS = ["Download App", "Disable Google authenticator"];
export const DISABLED_STEPS_COMPONENTS = [
  DownloadApp,
  Disable2FA
]
export const DISABLED_STEP_DESCRIPTIONS = [
  "Download and install the Google Authenticator app on your phone",
  "Google Authenticator Code",
];